module.exports = __webpack_public_path__ + "img/pt.4656b5ca.svg";